<template>
  <validation-observer
    #default="{ handleSubmit }"
    ref="refFormObserver"
  >
    <b-form
      class="list-view product-checkout"
      @submit.prevent="handleSubmit(onSubmit)"
    >

      <!-- Left Form -->
      <b-card no-body>
        <b-card-header class="flex-column align-items-start">
          <b-card-title>Adresim</b-card-title>
          <b-card-text class="text-muted mt-25">
            Teslimat ve Fatura gönderimi aynı adrese yapılacaktır.
          </b-card-text>
        </b-card-header>
        <b-card-body>
          <b-row>
            <!-- Radio Button -->
            <b-col
              cols="12"
              md="12"
            >
              <b-form-group
                v-slot="{ ariaDescribedby }"
              >
                <b-form-radio-group
                  id="radio-group-1"
                  v-model="selected"
                  :options="addressOptions"
                  :aria-describedby="ariaDescribedby"
                  name="radio-options"
                />
              </b-form-group>
            </b-col>

            <!-- Name -->
            <b-col
              cols="12"
              md="6"
            >
              <validation-provider
                #default="validationContext"
                name="Ad"
                rules="required"
              >
                <b-form-group
                  label="Ad"
                  label-for="name"
                  class="mb-2"
                >
                  <b-form-input
                    id="name"
                    v-model="getUserInfo.name"
                    :state="getValidationState(validationContext)"
                    trim
                  />
                  <b-form-invalid-feedback>
                    {{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>

            <!-- Surname -->
            <b-col
              cols="12"
              md="6"
              class="mb-2"
            >
              <validation-provider
                #default="validationContext"
                name="Soyad"
                rules="required"
              >
                <b-form-group
                  label="Soyad"
                  label-for="surname"
                >
                  <b-form-input
                    id="surname"
                    v-model="getUserInfo.surname"
                    :state="getValidationState(validationContext)"
                    trim
                  />
                  <b-form-invalid-feedback>
                    {{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>

            <!-- Identity No -->
            <b-col
              cols="12"
              md="12"
            >
              <validation-provider
                #default="validationContext"
                name="T.C.K. No"
                rules="required|regex:^[1-9]{1}[0-9]{9}[02468]{1}$"
              >
                <b-form-group
                  label="T.C.K. No"
                  label-for="identity"
                  class="mb-2"
                >
                  <b-form-input
                    id="identity"
                    v-model="getUserInfo.identity_number"
                    :state="getValidationState(validationContext)"
                    type="number"
                    trim
                  />
                  <b-form-invalid-feedback>
                    {{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>

            <!-- Firma Adi -->
            <b-col
              v-if="selected === 2"
              cols="12"
              md="6"
              class="mt-3"
            >
              <validation-provider
                #default="validationContext"
                name="Firma Adı"
                rules="required"
              >
                <b-form-group
                  label="Firma Adı"
                  label-for="name"
                  class="mb-2"
                >
                  <b-form-input
                    id="companyName"
                    v-model="getCompanyInfo.company_name"
                    :state="getValidationState(validationContext)"
                    trim
                  />
                  <b-form-invalid-feedback>
                    {{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>

            <!-- Vergi Dairesi -->
            <b-col
              v-if="selected === 2"
              cols="12"
              md="6"
              class="mt-3"
            >
              <validation-provider
                #default="validationContext"
                name="Vergi Dairesi"
                rules="required"
              >
                <b-form-group
                  label="Vergi Dairesi"
                  label-for="name"
                  class="mb-2"
                >
                  <b-form-input
                    id="taxLocation"
                    v-model="getCompanyInfo.company_tax_location"
                    :state="getValidationState(validationContext)"
                    trim
                  />
                  <b-form-invalid-feedback>
                    {{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>

            <!-- Vergi Numarasi -->
            <b-col
              v-if="selected === 2"
              cols="12"
              md="12"
              class="mb-3"
            >
              <validation-provider
                #default="validationContext"
                name="Vergi Numarası"
                rules="required"
              >
                <b-form-group
                  label="Vergi Numarası"
                  label-for="name"
                  class="mb-2"
                >
                  <b-form-input
                    id="taxNumber"
                    v-model="getCompanyInfo.company_tax_number"
                    :state="getValidationState(validationContext)"
                    trim
                  />
                  <b-form-invalid-feedback>
                    {{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>

            <!-- Address -->
            <b-col
              cols="12"
              md="12"
            >
              <validation-provider
                #default="validationContext"
                name="Adres"
                rules="required"
              >
                <b-form-group
                  label="Adres"
                  label-for="address"
                  class="mb-2"
                >
                  <b-form-input
                    id="address"
                    v-model="getUserInfo.registration_address"
                    :state="getValidationState(validationContext)"
                    trim
                  />
                  <b-form-invalid-feedback>
                    {{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>

            <!-- City -->
            <b-col
              cols="12"
              md="6"
            >
              <validation-provider
                #default="validationContext"
                name="Şehir"
                rules="required"
              >
                <b-form-group
                  label="Şehir"
                  label-for="city"
                  class="mb-2"
                >
                  <b-form-input
                    id="city"
                    v-model="getUserInfo.city"
                    :state="getValidationState(validationContext)"
                    trim
                  />
                  <b-form-invalid-feedback>
                    {{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>

            <!-- Country -->
            <b-col
              cols="12"
              md="6"
            >
              <validation-provider
                #default="validationContext"
                name="Ülke"
                rules="required"
              >
                <b-form-group
                  label="Ülke"
                  label-for="country"
                  class="mb-2"
                >
                  <b-form-input
                    id="country"
                    v-model="getUserInfo.country"
                    :state="getValidationState(validationContext)"
                    trim
                  />
                  <b-form-invalid-feedback>
                    {{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>

            <!-- postcode -->
            <b-col
              cols="12"
              md="6"
            >
              <validation-provider
                #default="validationContext"
                name="Posta Kodu"
                rules="required|integer"
              >
                <b-form-group
                  label="Posta Kodu"
                  label-for="pincode"
                  class="mb-2"
                >
                  <b-form-input
                    id="pincode"
                    v-model="getUserInfo.zip_code"
                    type="number"
                    :state="getValidationState(validationContext)"
                    trim
                  />
                  <b-form-invalid-feedback>
                    {{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>

            <!-- Email -->
            <b-col
              cols="12"
              md="6"
            >
              <validation-provider
                #default="validationContext"
                name="Email"
                rules="required|email"
              >
                <b-form-group
                  label="Email"
                  label-for="email"
                  class="mb-2"
                >
                  <b-form-input
                    id="email"
                    v-model="getUserInfo.email"
                    :state="getValidationState(validationContext)"
                    trim
                  />
                  <b-form-invalid-feedback>
                    {{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>

            <!-- GSM Number -->
            <b-col
              cols="12"
              md="6"
              class="mb-2"
            >
              <validation-provider
                #default="validationContext"
                name="Telefon Numarası"
                rules="required|integer"
              >
                <b-form-group
                  label="Telefon Numarası"
                  label-for="gsm-number"
                >
                  <b-form-input
                    id="gsm-number"
                    v-model="getUserInfo.gsm_number"
                    type="number"
                    :state="getValidationState(validationContext)"
                    trim
                  />
                  <b-form-invalid-feedback>
                    {{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>
          </b-row>
        </b-card-body>
      </b-card>

      <!-- Right Col -->
      <div class="customer-card">
        <b-card :title="`${getUserInfo.name} ${getUserInfo.surname}`">
          <b-card-text>
            {{ getUserInfo.identity_number }}
          </b-card-text>
          <b-card-text class="mb-0">
            {{ getUserInfo.registration_address }}
          </b-card-text>
          <b-card-text>{{ `${getUserInfo.zip_code}${getUserInfo.zip_code ? ',' : ''} ${getUserInfo.city} ${getUserInfo.city ? '-' : ''} ${getUserInfo.country}` }}</b-card-text>
          <b-card-text>{{ getUserInfo.email }}</b-card-text>
          <b-card-text>{{ getUserInfo.gsm_number }}</b-card-text>
          <b-button
            variant="primary"
            block
            type="submit"
          >
            Adresi Onayla
          </b-button>
        </b-card>
      </div>
    </b-form>
  </validation-observer>
</template>

<script>
import {
  BForm, BCard, BCardHeader, BCardTitle, BFormRadioGroup, BCardText, BCardBody, BRow, BCol, BFormGroup, BFormInput, BButton, BFormInvalidFeedback,
} from 'bootstrap-vue'
import { mapGetters, mapActions } from 'vuex'
import { ValidationProvider, ValidationObserver, localize } from 'vee-validate'
import tr from 'vee-validate/dist/locale/tr.json'
import { required, integer } from '@validations'
import formValidation from '@core/comp-functions/forms/form-validation'

export default {
  components: {
    // BSV
    BForm,
    BCard,
    BCardHeader,
    BCardTitle,
    BCardText,
    BCardBody,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BButton,
    BFormInvalidFeedback,
    BFormRadioGroup,

    // Form Validation
    ValidationProvider,
    ValidationObserver,
  },
  data() {
    return {
      selected: 1,
      addressOptions: [{
        value: 1,
        text: 'Bireysel',
      },
      {
        value: 2,
        text: 'Kurumsal',
      }],
    }
  },
  computed: {
    ...mapGetters({
      getUserInfo: 'eCommerce/getUserInfo',
      getCompanyInfo: 'eCommerce/getCompanyInfo',
      getUserPaymentCart: 'eCommerce/getUserPaymentCart',
    }),
  },
  mounted() {
    localize('tr', tr)
    this.cleanUserInfo()
    this.cleanUserPaymentCart()
  },
  setup(_, { emit }) {
    localize({ tr })
    const {
      refFormObserver,
      getValidationState,
      resetForm,
    } = formValidation(() => {})

    const onSubmit = () => {
      emit('next-step')
    }

    return {

      // Form
      onSubmit,

      // Form Validation
      refFormObserver,
      getValidationState,
      resetForm,

      // Form Validators
      required,
      integer,
    }
  },
  methods: {
    ...mapActions({
      updateUserInfoParams: 'eCommerce/updateUserInfoParams',
      cleanUserInfo: 'eCommerce/cleanUserInfo',
      updateUserPaymentCartParams: 'eCommerce/updateUserPaymentCartParams',
      cleanUserPaymentCart: 'eCommerce/cleanUserPaymentCart',
    }),
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
